module.exports = __webpack_public_path__ + "static/img/pic_jybjx@2x.bb0c2f13.png";